module.exports = __webpack_public_path__ + "static/media/turn.ec5e485b.wav";